import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AboutView.vue'),
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('../views/PrivacyView.vue'),
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import('../views/TermsView.vue'),
    },
    {
      path: '/marquee',
      name: 'marquee',
      component: () => import('../views/MarqueeView.vue'),
    },
    {
      path: '/sd-prompt',
      name: 'sd-prompt',
      component: () => import('../views/SDPromptView.vue'),
    },
    {
      path: '/pwd-generator',
      name: 'pwd-generator',
      component: () => import('../views/PwdGeneratorView.vue'),
    },
    {
      path: '/lucky-wheel',
      name: 'lucky-wheel',
      component: () => import('../views/LuckyWheelView.vue'),
    },
    {
      path: '/report',
      name: 'report',
      component: () => import('../views/ReportView.vue'),
    },
  ],
})

export default router
